/**
 * Digits in running text — a count, a time, a date, a case number — set as
 * figures, the words around them left alone (UX gate round 1, #13). For
 * lines that are built as one string elsewhere — the register's count line,
 * „seit heute 14:56 · verfällt am 06.10.2026" — so the sentence stays one
 * testable string and only its drawing splits.
 *
 * A figure is a run of digits, joined by `.`, `,`, `:` or a dash between
 * digits: „2026-0003", „14:56", „06.10.2026", „124.967,10" stay whole.
 *
 * Which face (UX gate round 4, #8): a Vorgang's number in mono, like every
 * ID (`.num`); a count, a time or a date in the UI face with tabular figures
 * (`.tabular`) — mono in running text set „0 offene Vorgänge" with a slashed
 * zero, which reads as Ø.
 */
const FIGURE = /\d+(?:[.,:\-–]\d+)*/g;

/** „2026-0003" — the shape of a case number (`case_no`, year and sequence). */
const CASE_NO = /^\d{4}-\d{3,}$/;

export function Figures({ text }: { text: string }) {
  const parts: (string | { figure: string })[] = [];
  let last = 0;
  for (const match of text.matchAll(FIGURE)) {
    const at = match.index;
    if (at > last) parts.push(text.slice(last, at));
    parts.push({ figure: match[0] });
    last = at + match[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return (
    <>
      {parts.map((part, index) =>
        typeof part === "string" ? (
          part
        ) : (
          <span key={index} className={CASE_NO.test(part.figure) ? "num" : "tabular"}>
            {part.figure}
          </span>
        ),
      )}
    </>
  );
}
